import * as React from 'react';
import { Link } from 'react-router-dom';

export const DocumentCard = ({ document }) => {
    const documentImage = document.image ? (<div className='image'>
        <img src={document.image} />
    </div>) : null;
    const documentBody = (<div className='content'>
        <div className='meta'>
            <span className='date'>{document.title}</span>
        </div>
    </div>);

    if (document.isEmbed) {
        if (document.embedFullScreen) {
            return (<a className='ui card' href={'/documents/fullscreen/' + document._id + '/fullscreen'} target='_blank'>
                {documentImage}
                {documentBody}
            </a>);
        }
        else {
            const link = '/documents/' + document._id;

            return (<Link className='ui card' to={link}>
                {documentImage}
                {documentBody}
            </Link>);
        }
    }
    else {
        return (<a className='ui card' href={document.file_url} target='_blank'>
            {documentImage}
            {documentBody}
        </a>);
    }
}



// WEBPACK FOOTER //
// ./src/components/common/document/document-card.presentation.tsx